import { render, staticRenderFns } from "./HighRiskCooperation.vue?vue&type=template&id=3074925b&scoped=true"
import script from "./HighRiskCooperation.vue?vue&type=script&lang=js"
export * from "./HighRiskCooperation.vue?vue&type=script&lang=js"
import style0 from "./HighRiskCooperation.vue?vue&type=style&index=0&id=3074925b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3074925b",
  null
  
)

export default component.exports